import Dashboard from "./Dashboard";
// System Admin sees the same dashboard for now
// Can be extended with platform-wide metrics when multi-org is supported
export default function SystemAdminDashboard() {
  return <Dashboard />;
}
